export enum TipoModalObservacion {
  ByR,
  Refacturacion
}
